//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


export default {
  props: {
    type: {
      type: String,
      default: 'resolved'
    },
    count: {
      type: [Number, String],
      default: null
    },
    rectangleWidth: {
      type: Number,
      default: 110
    },
    iconWidth: {
      type: Number,
      default: 31
    }
  },
  computed: {
    color: function () {
      switch (this.type) {
        case 'resolved':
          return '#7dbd4d;'
        case 'in-progress':
          return '#FC5A27;'
        case 'in-progress2':
          return '#000000b3;'
        case 'auto':
          return '#7DBD4D;'
        case 'manual':
          return '#FC5A27;'
        case 'overdue':
          return '#FC5A27;'
        case 'registered':
          return '#000000b3;'
        case 'received':
          return '#000000b3;'
        case 'black-and-yellow':
          return '#000000b3;'
        case 'others':
          return '#717BA2;'
        default:
          return ''
      }
    }
  }
}
